import apiFetch from '../apiFetch'

export default function () {
  window.open('appurl://magavision','_blank')
}
